import type { SVGProps } from 'react';

/**
 * A cloud with a key inside it: cloud credentials. Deliberately not the AWS
 * trademark. Uses `currentColor` so it follows the surrounding text colour
 * like the stock Lucide icons it sits beside.
 */
export const AwsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M17.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 1 1 0 9Z" />
    <circle cx="10" cy="13" r="1.6" />
    <path d="M11.6 13h4.4l-1.2 1.2M14.2 13l1.2 1.2" />
  </svg>
);
